import { SimpleGrid } from '@mantine/core';
import { IconCards } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/ui/PageHeader';
import { CardGridSkeleton, EmptyState, ErrorState } from '@/components/ui/StateViews';
import { lockedCopy } from '@/features/content/accessCopy';
import { fetchSpreads, SPREADS_KEY } from './api';
import { CatalogLockedOffer } from '@/features/access/PlanOffer';
import { SpreadCard } from './SpreadCard';

export function SpreadsListPage() {
  const navigate = useNavigate();
  const query = useQuery({ queryKey: SPREADS_KEY, queryFn: fetchSpreads });
  const items = query.data?.items ?? [];

  return (
    <>
      <PageHeader
        title="МАК-сессии"
        description="Готовые последовательности для самостоятельной работы и свободный стол для авторской сессии."
      />

      {query.isLoading ? (
        <CardGridSkeleton count={3} />
      ) : query.isError ? (
        <ErrorState onRetry={() => void query.refetch()} />
      ) : items.length === 0 ? (
        <EmptyState
          icon={<IconCards size={28} stroke={1.5} />}
          title="МАК-сессий пока нет"
          description="Опубликованные МАК-сессии появятся здесь."
        />
      ) : (
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="lg">
          {items.map((spread) => {
            const locked = lockedCopy(spread.access);
            return (
              <SpreadCard
                key={spread.id}
                spread={spread}
                lockedReason={locked?.reason ?? null}
                lockedHint={locked?.hint ?? null}
                onClick={() => void navigate(`/spreads/${spread.slug}`)}
              />
            );
          })}
        </SimpleGrid>
      )}
      <CatalogLockedOffer items={items.map((spread) => spread.access)} />
    </>
  );
}
